export default __webpack_public_path__ + "static/media/dev.9a8863ce.svg";